import { useCallback, useEffect, useState } from 'react';
import { SettingsLogos } from '../types/settings';
import { readSettingsClientCache } from '../utils/settingsSecureStorage';
import {
  applyCachedDocumentBranding,
  getCachedSettingsLogos,
  getHeaderLogoUrlFromLogos,
} from '../utils/settingsBranding';

function resolveDisplayName(cache: Awaited<ReturnType<typeof readSettingsClientCache>>): string {
  const trading =
    cache?.companyDetails?.tradingName?.trim() ||
    cache?.access?.tradingName?.trim();
  if (trading) return trading;
  const legal =
    cache?.companyDetails?.legalName?.trim() ||
    cache?.access?.legalName?.trim();
  return legal ?? '';
}

export function useSettingsBranding(syncDocumentHead = false) {
  const [logos, setLogos] = useState<SettingsLogos>({});
  const [headerLogoUrl, setHeaderLogoUrl] = useState('');
  const [displayName, setDisplayName] = useState('');

  const refresh = useCallback(async () => {
    if (syncDocumentHead) {
      await applyCachedDocumentBranding();
    }
    const cache = await readSettingsClientCache();
    const nextLogos = cache?.logos ?? cache?.access?.logos ?? (await getCachedSettingsLogos());
    setLogos(nextLogos);
    setHeaderLogoUrl(getHeaderLogoUrlFromLogos(nextLogos));
    setDisplayName(resolveDisplayName(cache));
  }, [syncDocumentHead]);

  useEffect(() => {
    void refresh();
    const onBranding = () => {
      void refresh();
    };
    window.addEventListener('zeettu-settings-branding', onBranding);
    return () => window.removeEventListener('zeettu-settings-branding', onBranding);
  }, [refresh]);

  return { logos, headerLogoUrl, displayName, refreshBranding: refresh };
};
